import type { EdrSeverityLevel } from './edrTokens';

/** Shared number formatter for EDR KPI/table cells (`—` when missing). */
export const formatEdrNumber = (value: number | undefined | null): string => {
  if (typeof value !== 'number' || Number.isNaN(value)) return '—';
  return value.toLocaleString();
};

export const toEdrTitleCase = (value: string | undefined | null): string => {
  if (!value) return '';
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};

/** Map API severity strings to `EdrSeverityLevel` (unknown → medium). */
export const toEdrSeverityLevel = (sev: string | undefined | null): EdrSeverityLevel => {
  const key = (sev ?? '').toString().trim().toLowerCase();
  if (key === 'critical' || key === 'high' || key === 'medium' || key === 'low') return key;
  if (key === 'informational' || key === 'info') return 'informational';
  return 'medium';
};

/** Standard Critical/High/Medium/Low filter pill options for EDR toolbars. */
export const EDR_SEVERITY_FILTER_OPTIONS: { label: string; value: string }[] = [
  { label: 'Critical', value: 'critical' },
  { label: 'High', value: 'high' },
  { label: 'Medium', value: 'medium' },
  { label: 'Low', value: 'low' },
];
